<div class="detail-content__video" *ngIf="projection?.videoUrl && isValidUrl(projection['videoUrl'])">
    <h3 class="font-weight-bold bold">{{ 'CARD_DETAIL.VIDEO' | translate }}</h3>
    <div class="detail-content__video-container">
      <iframe [src]="getVideoSafeUrl(projection.videoUrl)" width="100%" height="330" frameborder="0" allowfullscreen></iframe>
    </div>
</div>
